module.exports = __webpack_public_path__ + "static/media/main1.134b379d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/main1.jpg
// module id = 81
// module chunks = 0